var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearchDefaultLtr = function SvgSearchDefaultLtr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M41 9C23.327 9 9 23.327 9 41s14.327 32 32 32 32-14.327 32-32S58.673 9 41 9m0 5.895c14.417 0 26.105 11.687 26.105 26.105S55.417 67.105 41 67.105 14.895 55.418 14.895 41 26.582 14.895 41 14.895",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.064 66.82a3.002 3.002 0 0 0-4.185 4.305L86.875 92.12l.06.06a3.002 3.002 0 0 0 4.186-4.306L70.125 66.88z"
  })));
};
export default SvgSearchDefaultLtr;